import { Fragment, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import loginImg from '../../assets/login-signup.jpg';
import logo from '../../assets/Logo.svg';
import { Input } from '../../components/Input';
import { LoadingModal } from '../../components/LoadingModal';
import { ROUTES } from '../../constants/routes';
import { clearError, getCurrentUser, loginRequest } from '../../redux/slices/authSlice';

const Login = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const loading = useSelector((state) => state.auth.loading);
  const authError = useSelector((state) => state.auth.error);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error] = useState('');

  useEffect(() => {
    dispatch(clearError());
    return () => {
      dispatch(clearError());
    };
  }, [dispatch]);

  const handleLogin = (e) => {
    e.preventDefault();
    dispatch(loginRequest({ email, password }));
  };

  if (isAuthenticated) {
    dispatch(getCurrentUser());
    navigate(ROUTES.HOME);
  }

  const handleDismissError = () => {
    dispatch(clearError());
  };

  return (
    <Fragment>
      <ToastContainer />
      <div className="grid grid-cols-1 sm:grid-cols-2 md:h-screen w-full">
        <div className="hidden sm:block">
          <img className="w-full h-full object-cover" src={loginImg} alt="" />
        </div>

        <div className="bg-white md:bg-gray-100 flex flex-col justify-start md:justify-center">
          {(loading || authError) && (
            <LoadingModal
              message="logging in..."
              error={authError}
              onClose={authError ? handleDismissError : null}
            />
          )}
          <div className="bg-white md:bg-gray-100 flex flex-col justify-start md:justify-center">
            <form
              onSubmit={handleLogin}
              className="max-w-[450px] w-full mx-auto bg-white px-8 py-16 md:py-8 shadow-none md:shadow-md"
            >
              <Link to={ROUTES.HOME}>
                <img src={logo} className="w-[60%] mx-auto" />
              </Link>
              <Input
                name="username"
                type="text"
                label="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Input
                name="password"
                type="password"
                label="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
              <button
                type="submit"
                className="border w-full mt-2 mb-4 py-3 bg-lime-700 hover:bg-lime-800 text-white"
              >
                Sign In
              </button>

              <div className="flex justify-between">
                <p className="flex items-center">
                  <input className="mr-2" type="checkbox" /> Remember Me
                </p>
                <Link to={ROUTES.SIGNUP} className="text-blue-600 hover:text-blue-800">
                  Don't have an account? Sign up
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export { Login };
